import React, { useCallback } from 'react';

import { useHistory } from 'react-router-dom';

import { useActions, useTypedSelector } from '../../../hooks';
import { DownloadAppDialog } from '../../main/components/DownloadAppDialog';

const TITLE = 'Finish onboarding on the Vyce app';
const DESCRIPTION =
  "You've been invited to join your team on Vyce. Download the mobile app to complete your profile.";

export const EmployeeAppDialog: React.FC = () => {
  const user = useTypedSelector(state => state.user);
  const { clearUser } = useActions();
  const history = useHistory();

  const handleMaybeLater = useCallback(() => {
    if (user.employee?.uuid) {
      history.push('/dashboard');
      return;
    }
    clearUser();
    history.push('/auth/login');
  }, [user.employee?.uuid, clearUser, history]);

  return (
    <DownloadAppDialog
      open
      onClose={handleMaybeLater}
      title={TITLE}
      description={DESCRIPTION}
      showCloseButton={false}
    />
  );
};
